import React from "react";
import { AppBar, Toolbar, IconButton, Typography } from "@mui/material";
import { Menu as MenuIcon } from "@mui/icons-material";
import vsDarkTheme from "../theme/vsDarkTheme";

const drawerWidth = 240;

export default function MobileAppBar({ onMenuClick }) {
  return (
    <AppBar
      position="fixed"
      sx={{
        width: { sm: `calc(100% - ${drawerWidth}px)` },
        ml: { sm: `${drawerWidth}px` },
        backgroundColor: '#252526',
        boxShadow: 'none',
        borderBottom: '1px solid #3e3e42'
      }}
    >
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={onMenuClick}
          sx={{ mr: 2, display: { sm: 'none' } }}
        >
          <MenuIcon />
        </IconButton>
        <Typography variant="h6" noWrap component="div" sx={{ color: vsDarkTheme.palette.primary.main }}>
          Victor Rios
        </Typography>
      </Toolbar>
    </AppBar>
  );
}
